import React, { ReactNode, useCallback, useContext } from 'react'
import { AccountContext } from '../account/AccountContext';
import { FilterAction } from '../account/filtering/FilterAction';
import { bigNumber, decimal, formatMoney } from '../utils/money-utils'

export function useFilterActionTrigger(filter: FilterAction.badStatus | FilterAction.badBalance | FilterAction.noInfo, sorter: string){
    const {dispatch} = useContext(AccountContext)
    return useCallback(() => {
        dispatch({type: FilterAction.clearFilters})
        dispatch({type:filter, payload:true})
        dispatch({type: "setSorter", payload: {id: sorter, order: "asc"}});
    }, [filter, sorter]);
}


export function CounterCard({title, count, onClick = null, footer = null}:{title:ReactNode, footer?:ReactNode, count:number, onClick?:()=>void}){
    return <div className='card counter-card' onClick={onClick} style={onClick ? {cursor:"pointer"} : null}>
        <div className='card-body text-center p-2'>
            <div className='mb-1'>{title}</div>
            <div className='fw-bold fs-2'>{bigNumber(count)}</div>
            {footer}
        </div>
    </div>
}

export function PercentCard({title, ratio, onClick = null}:{title:ReactNode, ratio:number, onClick?:()=>void}){
    return <div className='card counter-card' onClick={onClick} style={onClick ? {cursor:"pointer"} : null}>
        <div className='card-body text-center p-2'>
            <div className='mb-1'>{title}</div>
            <div className='fw-bold fs-2'>{decimal(ratio * 100)}%</div>
        </div>
    </div>
}

export function FloatCard({title, value, onClick = null}:{title:ReactNode, value:number, onClick?:()=>void}){
    return <div className='card counter-card' onClick={onClick} style={onClick ? {cursor:"pointer"} : null}>
        <div className='card-body text-center p-2'>
            <div className='mb-1'>{title}</div>
            <div className='fw-bold fs-2'>{decimal(value,2)}</div>
        </div>
    </div>
}

export function MoneyCounterCard({title, count, footer = null}:{title:ReactNode, footer?:ReactNode, count:number}){
    const m = formatMoney(count).match(/R\$ ([\d\.]+)\,(\d+)/);
    const [value, cents] = m == null ? ['0', '00'] : [m[1], m[2]];
    return <div className='card counter-card money-card'>
        <div className='card-body text-center p-2'>
            <div className='mb-1 text-truncate'>{title}</div>
            <div className='fw-bold fs-2'><small>R$</small>{value}<small>,{cents}</small></div>
            {footer}
        </div>
    </div>
}